import React, { useState, useEffect, useRef, useMemo } from 'react';
import { getStorage, ref, getDownloadURL } from 'firebase/storage';
import { useLocation, Link } from 'react-router-dom';
import { getProducts, getCategories } from '../services/firestoreService';
import { useCart } from '../contexts/CartContext';
import styles from './ProductCatalog.module.css'; // Import CSS module
import { useSpring, animated } from '@react-spring/web'; // Import React Spring
import flowerIcon from '../images/flower.ico';
import Swal from 'sweetalert2';
import Modal from 'react-modal';
const SKELETON_COUNT = 9;


const ProductCatalog = ({ toggleCartSidebar }) => {

  const [products, setProducts] = useState([]);
  const [categories, setCategories] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [category, setCategory] = useState('');
  const [sort, setSort] = useState('');
  const [selectedOption, setSelectedOption] = useState({});
  const [modalProduct, setModalProduct] = useState(null); // For handling product options modal
  const [tarjetaModalProduct, setTarjetaModalProduct] = useState(null); // For handling tarjeta message modal
  const [isAnimating, setIsAnimating] = useState(false); // Track animation state
  const [animationPosition, setAnimationPosition] = useState({}); // Store animation start position
  const [isAnimatingFlowerInNavBar, setIsAnimatingFlowerInNavBar] = useState(false); // Track navbar flower animation
  const { addToCart } = useCart();
  const location = useLocation();
  const [tarjetaMessage, setTarjetaMessage] = useState(''); // State for "Tarjeta" message
  const [loadedImages, setLoadedImages] = useState({});
// Map: productId -> derived principal webp URL
const [principalWebp, setPrincipalWebp] = useState({});
const [loadingProducts, setLoadingProducts] = useState(true);

const PER_PAGE = 15;
const topAnchorOffset = 80; // pixels to offset for sticky navbar if needed

// pagination + anchor
const [page, setPage] = useState(1);
const topAnchorRef = useRef(null);


  const handleImageLoad = (productId) => {
    setLoadedImages((prev) => ({ ...prev, [productId]: true }));
  };

useEffect(() => {
  const query = new URLSearchParams(location.search);
  const search = query.get('search');
  if (search) {
    setSearchTerm(search);
  }

  (async () => {
    try {
      setLoadingProducts(true);

      const [productsSnapshot, categoriesSnapshot] = await Promise.all([
        getProducts(),
        getCategories(),
      ]);

      const productsList = productsSnapshot.docs
        .map(doc => ({ id: doc.id, ...doc.data() }))
        .filter(product => !product.disabled);

      const categoriesList = categoriesSnapshot.docs
        .map(doc => ({ id: doc.id, ...doc.data() }))
        .filter(category => !category.disabled);

      setProducts(productsList);
      setCategories(categoriesList);
    } catch (err) {
      console.error('Failed to fetch products/categories:', err);
    } finally {
      setLoadingProducts(false);
    }
  })();
}, [location.search]);





  const handleSortChange = (e) => {
    const { value } = e.target;
    setSort(value);
  };

  const handleCategoryChange = (e) => {
    const { value } = e.target;
    setCategory(value);
  };

  const startAnimation = (productElement) => {
    const cartIcon = document.getElementById('cart-icon'); // Get cart icon

    if (cartIcon && productElement) {
      const productPosition = productElement.getBoundingClientRect();
      const cartPosition = cartIcon.getBoundingClientRect();

      // Calculate position relative to document (considering scroll)
      const scrollY = window.scrollY || window.pageYOffset;
      const scrollX = window.scrollX || window.pageXOffset;

      setAnimationPosition({
        fromX: productPosition.x + scrollX,
        fromY: productPosition.y + scrollY,
        toX: cartPosition.x + scrollX,
        toY: cartPosition.y + scrollX,
      });

      setIsAnimating(true);
      setIsAnimatingFlowerInNavBar(true); // Trigger navbar flower animation
      setTimeout(() => {
        setIsAnimating(false);
        setIsAnimatingFlowerInNavBar(false); // Stop the animation in the navbar after the transition
      }, 1000); // Duration of the animation
    }
  };

  const handleOptionSelect = (productId, option) => {
    setSelectedOption({ ...selectedOption, [productId]: option });
  };

  const handleAddToCart = (product, event) => {
    const productElement = event.currentTarget.closest('.card');
    const option = selectedOption[product.id];
    const quantity = 1;
  
    if (product.options && product.options.length > 0 && (!option || option === "")) {
      setModalProduct(product);
      return;
    }
  
    if (product.hasTarjeta) {
      setTarjetaModalProduct(product);
      return;
    }
  
    const selectedProduct = {
      ...product,
      price: option ? option.price : product.price,
      option: option || null,
      tarjetaMessage: null,
      quantity,
    };
  
    startAnimation(productElement);
    addToCart(selectedProduct, toggleCartSidebar); // Open the cart sidebar
  };
  


  const handleModalAddToCart = () => {
    const product = modalProduct;
    const option = selectedOption[product.id];
  
    if (product.options && product.options.length > 0 && (!option || option === "")) {
      Swal.fire('Selecciona una Opción', 'Por favor selecciona una opción válida.', 'warning');

      return;
    }
  
    if (product.hasTarjeta) {
      setTarjetaModalProduct(product);
      setModalProduct(null); // Close options modal, open tarjeta modal
    } else {
      const selectedProduct = {
        ...product,
        price: option ? option.price : product.price,
        option,
        tarjetaMessage: null,
        quantity: 1,
      };
  
      startAnimation(document.getElementById(`product-${product.id}`)); // Animate product to cart
      addToCart(selectedProduct, toggleCartSidebar); // Open the cart sidebar after adding the product
      setModalProduct(null); // Close the modal after adding to cart
    }
  };
  

  const handleTarjetaSave = () => {
    const product = tarjetaModalProduct;
  
    const selectedProduct = {
      ...product,
      price: product.price,
      option: selectedOption[product.id] || null, // Use selected option if any
      tarjetaMessage, // Include the tarjeta message
      quantity: 1,
    };
  
    startAnimation(document.getElementById(`product-${product.id}`)); // Animate product to cart
    addToCart(selectedProduct, toggleCartSidebar); // Open the cart sidebar after adding the product
    setTarjetaModalProduct(null); // Close tarjeta modal after saving
    setTarjetaMessage(''); // Reset tarjeta message
  };
  

  const handleTarjetaSkip = () => {
    const product = tarjetaModalProduct;

    const selectedProduct = {
      ...product,
      price: product.price,
      option: selectedOption[product.id] || null, // Use selected option if any
      tarjetaMessage: null, // Skip the tarjeta message
      quantity: 1, // Set default quantity to 1
    };

    startAnimation(document.getElementById(`product-${product.id}`)); // Animate product to cart
    addToCart(selectedProduct, toggleCartSidebar);
    setTarjetaModalProduct(null); // Close tarjeta modal after skipping
    setTarjetaMessage(''); // Reset tarjeta message
  };

  const filteredProducts = products
  .filter((product) =>
    product.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
    product.category.toLowerCase().includes(searchTerm.toLowerCase()) ||
    (product.shortDescription && product.shortDescription.toLowerCase().includes(searchTerm.toLowerCase())) ||
    (product.fullDescription && product.fullDescription.toLowerCase().includes(searchTerm.toLowerCase()))
  )
  .filter((product) =>
    category
      ? product.category === category || (product.categories && product.categories.includes(category))
      : true
  )
  .sort((a, b) => {
    if (sort === 'price-asc') return a.price - b.price;
    if (sort === 'price-desc') return b.price - a.price;
    if (sort === 'popularity') return b.popularity - a.popularity;
    return 0;
  });

// total pages and current slice
const totalPages = Math.max(1, Math.ceil(filteredProducts.length / PER_PAGE));
const pageProducts = useMemo(
  () => filteredProducts.slice((page - 1) * PER_PAGE, page * PER_PAGE),
  [filteredProducts, page]
);


useEffect(() => {
  let cancelled = false;

  (async () => {
    if (!pageProducts?.length) return;

    const storage = getStorage();

    const entries = await Promise.all(
      pageProducts.map(async (p) => {
        const orig = p.principalImageUrl || p.imageUrls?.[0];
        if (!orig) return [p.id, null];

        try {
          const encoded = new URL(orig).pathname.split('/o/')[1]?.split('?')[0];
          if (!encoded) return [p.id, null];

          const objectPath = decodeURIComponent(encoded);
          const webpPath = objectPath.replace(/\.[^.]+$/, '-w1200.webp');

          const url = await getDownloadURL(ref(storage, webpPath));
          return [p.id, url];
        } catch {
          return [p.id, null];
        }
      })
    );

    if (!cancelled) {
      // merge, so previously fetched pages stay cached if you go back
      setPrincipalWebp((prev) => ({
        ...prev,
        ...Object.fromEntries(entries.filter(([, u]) => u)),
      }));
    }
  })();

  return () => { cancelled = true; };
}, [pageProducts]);

// reset/clamp page when filters/search change or results shrink
useEffect(() => {
  if (page > totalPages) setPage(totalPages);
  if (page < 1) setPage(1);
  // when search/category/sort changes, go back to page 1
}, [filteredProducts.length, totalPages]);


  const formatCurrency = (value) => {
    return new Intl.NumberFormat('es-CR', {
      style: 'currency',
      currency: 'CRC',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).format(value);
  };

  const goToPage = (p) => {
  const next = Math.min(Math.max(1, p), totalPages);
  setPage(next);

  // scroll to the top anchor (offset ~80px for sticky navbar)
  requestAnimationFrame(() => {
    if (topAnchorRef.current) {
      const y = topAnchorRef.current.getBoundingClientRect().top + window.scrollY - 80;
      window.scrollTo({ top: y, behavior: 'smooth' });
    }
  });
};

const handlePrev = () => goToPage(page - 1);
const handleNext = () => goToPage(page + 1);

const PaginationBar = () => (
  <nav className={styles.pagerBar} aria-label="Paginación de productos">
    <div className={styles.pagerMeta}>
      {filteredProducts.length} productos • Página {page} de {totalPages}
    </div>

    <div className={styles.pagerBtns}>
      <button
        type="button"
className={`btn btn-primary btn-sm ${styles.pagerButton}`}
        onClick={handlePrev}
        onMouseDown={(e) => e.preventDefault()}
        disabled={page <= 1}
      >
        Anterior
      </button>

      <button
        type="button"
className={`btn btn-primary btn-sm ${styles.pagerButton}`}
        onClick={handleNext}
        onMouseDown={(e) => e.preventDefault()}
        disabled={page >= totalPages}
      >
        Siguiente
      </button>
    </div>
  </nav>
);


  // Animation for search bar, category, and sort selects
  const searchBarAnimation = useSpring({
    from: { opacity: 0, transform: 'translateY(-20px)' },
    to: { opacity: 1, transform: 'translateY(0)' },
  });

  const flowerAnimation = useSpring({
    from: { left: `${animationPosition.fromX}px`, top: `${animationPosition.fromY}px`, opacity: 1 },
    to: { left: `${animationPosition.toX}px`, top: `${animationPosition.toY}px`, opacity: 0 },
    config: { duration: 1000 },
    reset: isAnimating,
    onRest: () => setIsAnimating(false),
  });

  const SkeletonCard = () => (
  <div className="col-md-4 d-flex">
    <div className={`${styles.card} ${styles.skeletonCard} card mb-4`}>
      <div className={styles.skeletonThumb} />
      <div className={styles.skeletonBody}>
        <div className={styles.skeletonLine} />
        <div className={styles.skeletonLineShort} />
        <div className={styles.skeletonPrice} />
        <div className={styles.skeletonLineXS} />
        <div className={styles.skeletonBtns}>
          <div className={styles.skeletonBtn} />
          <div className={styles.skeletonBtn} />
        </div>
      </div>
    </div>
  </div>
);


  return (
    <div className={`${styles.container} ${styles.catalogContainer}`}>
      <h2 className="my-4">Nuestros Productos</h2>
      <div ref={topAnchorRef} />
     

      {loadingProducts ? (
        <div className={styles.skeletonFilters}>
          <div className={styles.skeletonBar} />
          <div className={styles.skeletonBar} />
          <div className={styles.skeletonBar} />
        </div>
      ) : (
        <animated.div style={searchBarAnimation} className={styles.searchContainer}>
          <input
            type="text"
            className={`form-control ${styles.searchBar}`}
            placeholder="Buscar productos..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
          <select
            className={`form-control mt-2 ${styles.categorySelect}`}
            value={category}
            onChange={handleCategoryChange}
          >
            <option value="">Todas las Categorías</option>
            {categories.map((cat) => (
              <option key={cat.id} value={cat.name}>
                {cat.name}
              </option>
            ))}
          </select>
          <select
            className={`form-control mt-2 ${styles.sortSelect}`}
            value={sort}
            onChange={handleSortChange}
          >
            <option value="">Filtros</option>
            <option value="price-asc">Precio: Menor a Mayor</option>
            <option value="price-desc">Precio: Mayor a Menor</option>
            <option value="popularity">Popularidad</option>
          </select>
        </animated.div>
        
      )}
       <PaginationBar />



<div className="row">
  {loadingProducts
    ? Array.from({ length: SKELETON_COUNT }).map((_, i) => <SkeletonCard key={`sk-${i}`} />)
      : pageProducts.map((product, idx) => {
        const selectedPrice = selectedOption[product.id]?.price || product.price;
          const principalSrc = principalWebp[product.id] || product.principalImageUrl || product.imageUrls?.[0];

        return (
          <div key={product.id} className="col-md-4 d-flex" id={`product-${product.id}`}>
            <div className={`card mb-4 ${styles.card}`}>
              {/* Product image with responsive sources */}
              <div className={styles['card-img-container']}>
                {/* optional tiny preview if present */}



              <picture>
                {principalWebp[product.id] && (
                  <source type="image/webp" srcSet={`${principalWebp[product.id]} 1x`} />
                )}
                  <img
                    key={`${product.id}-${principalSrc}`}
                    className={styles['card-img-top']}
                    alt={product.name}
                    src={principalSrc}

                    /* Prioritize the first few visible cards (usually first row or two) */
                    loading={idx < 6 ? 'eager' : 'lazy'}
                    fetchpriority={idx < 6 ? 'high' : 'auto'}

                    /* Help the browser select the right size and reserve space */
                    sizes="(min-width: 992px) 33vw, (min-width: 768px) 50vw, 100vw"
                    width="600"
                    height="600"

                    decoding="async"
                    onLoad={(e) => {
                      e.currentTarget.classList.add(styles.imageLoaded);
                      const c = e.currentTarget.closest(`.${styles['card-img-container']}`);
                      if (c) c.classList.add(styles.loaded);
                    }}
                    onError={(e) => {
                      e.currentTarget.classList.add(styles.imageError);
                      const c = e.currentTarget.closest(`.${styles['card-img-container']}`);
                      if (c) c.classList.add(styles.loaded);
                    }}
                  />

              </picture>


                
              </div>

              <div className={`card-body ${styles.cardBody}`}>
                <h5 className={`card-title ${styles.cardTitle}`}>{product.name}</h5>
                <p className={`card-text ${styles.cardText}`}>
                  {product.shortDescription}
                </p>
                <p className={`card-text ${styles.productPrice}`}>
                  <strong>{formatCurrency(selectedPrice)}</strong>
                </p>
                <p className={`card-text ${styles.productCategory}`}>Categoría: {product.category}</p>
                <p className={`card-text ${styles.productStock}`}>
                  Stock: {product.stock > 0 ? product.stock : 'Agotado'}
                </p>

                {product.options && product.options.length > 0 && (
                  <select
                    onChange={(e) => handleOptionSelect(product.id, JSON.parse(e.target.value))}
                    className={`form-control mt-2 ${styles.optionSelect}`}
                    defaultValue=""
                  >
                    <option value="" disabled>Selecciona una Opción</option>
                    {product.options.map((opt, index) => (
                      <option key={index} value={JSON.stringify(opt)}>
                        {opt.name} - {formatCurrency(opt.price)}
                      </option>
                    ))}
                  </select>
                )}

                <button 
                  onClick={(e) => handleAddToCart(product, e)} 
                  className={`btn btn-primary ${styles.productButton}`} 
                  disabled={product.stock <= 0}
                >
                  {product.stock > 0 ? 'Agregar al Carrito' : 'Agotado'}
                </button>

                <Link to={`/products/${product.id}`}>
                  <button className={`btn btn-secondary mt-2 ${styles.productButton}`}>Ver Producto</button>
                </Link>
              </div>
            </div>
          </div>
        );
      })}
</div>
<PaginationBar />



      {isAnimating && (
        <animated.img src={flowerIcon} style={flowerAnimation} className={styles.flowerAnimation} />
      )}
  
      {/* Modal for product options */}
      <Modal
        isOpen={!!modalProduct}
        onRequestClose={() => setModalProduct(null)}
        contentLabel="Selecciona una Opción"
        style={{
          content: {
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            transform: 'translate(-50%, -50%)',
            width: '450px', // Small width
            height: 'auto',
            padding: '20px',
            backgroundColor: 'white',
            borderRadius: '8px',
            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
          },
          overlay: {
            backgroundColor: 'rgba(0, 0, 0, 0.4)', // Darker overlay for focus
          },
        }}
      >
        {modalProduct && (
          <div>
            <h4>Select an option for {modalProduct.name}</h4>
            <select
              onChange={(e) => handleOptionSelect(modalProduct.id, JSON.parse(e.target.value))}
              className={`form-control mt-2 ${styles.optionSelect}`}
            >
              <option value="" disabled selected>Selecciona una Opción</option> {/* Disable placeholder */}
              {modalProduct.options.map((opt, index) => (
                <option key={index} value={JSON.stringify(opt)}>
                  {opt.name} - {formatCurrency(opt.price)}
                </option>
              ))}
            </select>
            <button className="btn btn-primary mt-3" onClick={handleModalAddToCart}>
              Agregar al Carrito
            </button>
          </div>
        )}
      </Modal>
  
      {/* Modal for "Tarjeta" message */}
      <Modal
        isOpen={!!tarjetaModalProduct}
        onRequestClose={() => setTarjetaModalProduct(null)}
        contentLabel="Enter Tarjeta Message"
        style={{
          content: {
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            transform: 'translate(-50%, -50%)',
            width: '450px',
            height: 'auto',
            padding: '20px',
            backgroundColor: 'white',
            borderRadius: '8px',
            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
          },
          overlay: {
            backgroundColor: 'rgba(0, 0, 0, 0.4)', // Darker overlay for focus
          },
        }}
      >
        {tarjetaModalProduct && (
          <div>
            <h4>Escribe tu mensaje para la tarjetita</h4>
            <input
              type="text"
              id={`tarjeta-modal-message`}
              className="form-control"
              placeholder="Tu mensaje..."
              value={tarjetaMessage}
              onChange={(e) => setTarjetaMessage(e.target.value)}
            />
            <div className="mt-3 d-flex justify-content-between">
              <button className="btn btn-primary" onClick={handleTarjetaSave}>
                Guardar Mensaje
              </button>
              <button className="btn btn-secondary" onClick={handleTarjetaSkip}>
                Saltar
              </button>
            </div>
          </div>
        )}
      </Modal>
    </div>
  );
  
  
};

export default ProductCatalog;
